

app.controller('CIF3-CTRL',
    ['$scope', '$rootScope', '$http', '$window', '$q', '$filter',
    function ($scope, $rootScope, $http, $window, $q, $filter) {
    $scope.CIFInvestor = {}


    $scope.chkquestionfatca = true;
    $scope.chkquestion1 = false;
    $scope.chkquestion2 = false;
    $scope.chkquestion3 = false;
    $scope.chkquestion4 = false;

    $scope.print = function () {
        $scope.prepareData();
    }



    var allPromise = $q.all([
       $http({
           method: 'GET',
           url: 'service/client.svc/GetCIFLookup',
           cache: true,
       }).then(function (data) {
           $scope.ListLookup = data.data.d;
           if ($scope.ListLookup) {
               $scope.ListInvestmentObjectives = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);
               $scope.ListRisk = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Risk' }, true);

           }
       }, function (error) { }),

       $http({
           method: 'POST',
           url: 'service/client.svc/retrieveSession',
       }).then(function (data) {
           if (!data.data.d) {
               $http({
                   method: 'GET',
                   url: 'service/client.svc/SignOut',
               }).then(function (data) {
                   if (data.data.d == true) {
                       $window.location.href = "#/login";
                       $window.location.reload();
                   }
               }, function (error) { })
           }
           else
               $scope.currentUser = data.data.d;
       }, function (error) { }),
         $http({
             method: 'GET',
             url: 'service/client.svc/GetPED',
         }).then(function (data) {

             if (data.data.d != null) {
                 $scope.broker = data.data.d;
                 console.log(" Name", $scope.broker.BROKERName);
             }
         }, function (error) { }),
    ]);

    allPromise.then(function () {
        $http({
            method: 'GET',
            url: 'service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 3;

                if ($scope.CIFInvestor.FATCA1 == 'Ya' || $scope.CIFInvestor.FATCA2 == 'Ya' || $scope.CIFInvestor.FATCA3 == 'Ya') {
                    $scope.chkquestionfatca = false;
                }

                if ($scope.CIFInvestor.InvestmentObjectives == 0)
                    $scope.CIFInvestor.InvestmentObjectives = '';

                //if ($scope.CIFInvestor.Risk == 0)
                //    $scope.CIFInvestor.Risk = '';

            } // END IF data.data.d
        }, function (error) { });
    });

    $scope.prepareData = function () {
        console.log($scope.CIFInvestor);

        if ($scope.chkquestion1) {
            if ($scope.chkquestion1 = true) {
                $scope.CIFInvestor.Question1 = 'Ya';
                $scope.CIFInvestor.Question1_Text = '';
            }
        }

        if ($scope.chkquestion2) {
            if ($scope.chkquestion2 = true) {
                $scope.CIFInvestor.Question2 = 'Ya';
                $scope.CIFInvestor.Question2_Text = '';
            }
        }

        if ($scope.chkquestion3) {
            if ($scope.chkquestion1 = true) {
                $scope.CIFInvestor.Question3 = 'Ya';
                $scope.CIFInvestor.Question3_Text = '';
            }
        }

        if ($scope.chkquestion4) {
            if ($scope.chkquestion4 = true) {
                $scope.CIFInvestor.Question4 = 'Ya';
                $scope.CIFInvestor.Question4_Text = '';
            }
        }

        if ($scope.chkquestion5) {
            if ($scope.chkquestion5 = true) {
                $scope.CIFInvestor.Question5 = 'Ya';
                $scope.CIFInvestor.Question5_Text = '';
            }
        }

        if ($scope.chkquestion6) {
            if ($scope.chkquestion6 = true) {
                $scope.CIFInvestor.Question6 = 'Ya';
                $scope.CIFInvestor.Question6_Text = '';
            }
        }

        if ($scope.chkquestionfatca) {
            if ($scope.chkquestionfatca = true) {

                $scope.CIFInvestor.FATCA1 = 'Tidak';
                $scope.CIFInvestor.FATCA2 = 'Tidak';
                $scope.CIFInvestor.FATCA3 = 'Tidak';
            }
        }

        $scope.CIFInvestor.IsFinished = 0;
        $scope.CIFInvestor.Stage = 3;

    }

    $scope.trim = function(){
        $scope.CIFInvestor.BankCabang=$scope.CIFInvestor.BankCabang?$scope.CIFInvestor.BankCabang.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BankCabang;
        $scope.CIFInvestor.BankName=$scope.CIFInvestor.BankName?$scope.CIFInvestor.BankName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BankName;
        $scope.CIFInvestor.BankNumber=$scope.CIFInvestor.BankNumber?$scope.CIFInvestor.BankNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BankNumber;
        $scope.CIFInvestor.BankOwner=$scope.CIFInvestor.BankOwner?$scope.CIFInvestor.BankOwner.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BankOwner;
        $scope.CIFInvestor.BirthPlace=$scope.CIFInvestor.BirthPlace?$scope.CIFInvestor.BirthPlace.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.BirthPlace;
        $scope.CIFInvestor.Branch=$scope.CIFInvestor.Branch?$scope.CIFInvestor.Branch.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Branch;
        $scope.CIFInvestor.CompanyAddress=$scope.CIFInvestor.CompanyAddress?$scope.CIFInvestor.CompanyAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.CompanyAddress;
        $scope.CIFInvestor.CompanyName=$scope.CIFInvestor.CompanyName?$scope.CIFInvestor.CompanyName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.CompanyName;
        $scope.CIFInvestor.DomicileAddress=$scope.CIFInvestor.DomicileAddress?$scope.CIFInvestor.DomicileAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileAddress;
        $scope.CIFInvestor.DomicileKecamatan=$scope.CIFInvestor.DomicileKecamatan?$scope.CIFInvestor.DomicileKecamatan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileKecamatan;
        $scope.CIFInvestor.DomicileKelurahan=$scope.CIFInvestor.DomicileKelurahan?$scope.CIFInvestor.DomicileKelurahan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileKelurahan;
        $scope.CIFInvestor.DomicilePostalCode=$scope.CIFInvestor.DomicilePostalCode?$scope.CIFInvestor.DomicilePostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicilePostalCode;
        $scope.CIFInvestor.DomicileRT=$scope.CIFInvestor.DomicileRT?$scope.CIFInvestor.DomicileRT.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileRT;
        $scope.CIFInvestor.DomicileRW=$scope.CIFInvestor.DomicileRW?$scope.CIFInvestor.DomicileRW.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.DomicileRW;
        $scope.CIFInvestor.EducationText=$scope.CIFInvestor.EducationText?$scope.CIFInvestor.EducationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.EducationText;
        $scope.CIFInvestor.Email=$scope.CIFInvestor.Email?$scope.CIFInvestor.Email.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Email;
        $scope.CIFInvestor.FATCA1=$scope.CIFInvestor.FATCA1?$scope.CIFInvestor.FATCA1.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FATCA1;
        $scope.CIFInvestor.FATCA2=$scope.CIFInvestor.FATCA2?$scope.CIFInvestor.FATCA2.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FATCA2;
        $scope.CIFInvestor.FATCA3=$scope.CIFInvestor.FATCA3?$scope.CIFInvestor.FATCA3.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FATCA3;
        $scope.CIFInvestor.FirstName=$scope.CIFInvestor.FirstName?$scope.CIFInvestor.FirstName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FirstName;
        $scope.CIFInvestor.FundSource=$scope.CIFInvestor.FundSource?$scope.CIFInvestor.FundSource.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FundSource;
        $scope.CIFInvestor.FundSourceText=$scope.CIFInvestor.FundSourceText?$scope.CIFInvestor.FundSourceText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.FundSourceText;
        $scope.CIFInvestor.IDCardAddress=$scope.CIFInvestor.IDCardAddress?$scope.CIFInvestor.IDCardAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardAddress;
        $scope.CIFInvestor.IDCardKecamatan=$scope.CIFInvestor.IDCardKecamatan?$scope.CIFInvestor.IDCardKecamatan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardKecamatan;
        $scope.CIFInvestor.IDCardKelurahan=$scope.CIFInvestor.IDCardKelurahan?$scope.CIFInvestor.IDCardKelurahan.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardKelurahan;
        $scope.CIFInvestor.IDCardNumber=$scope.CIFInvestor.IDCardNumber?$scope.CIFInvestor.IDCardNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardNumber;
        $scope.CIFInvestor.IDCardPostalCode=$scope.CIFInvestor.IDCardPostalCode?$scope.CIFInvestor.IDCardPostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardPostalCode;
        $scope.CIFInvestor.IDCardRT=$scope.CIFInvestor.IDCardRT?$scope.CIFInvestor.IDCardRT.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardRT;
        $scope.CIFInvestor.IDCardRW=$scope.CIFInvestor.IDCardRW?$scope.CIFInvestor.IDCardRW.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.IDCardRW;
        $scope.CIFInvestor.MobilePhone=$scope.CIFInvestor.MobilePhone?$scope.CIFInvestor.MobilePhone.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.MobilePhone;
        $scope.CIFInvestor.MotherName=$scope.CIFInvestor.MotherName?$scope.CIFInvestor.MotherName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.MotherName;
        $scope.CIFInvestor.NPWPNumber=$scope.CIFInvestor.NPWPNumber?$scope.CIFInvestor.NPWPNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.NPWPNumber;
        $scope.CIFInvestor.NPWPReason=$scope.CIFInvestor.NPWPReason?$scope.CIFInvestor.NPWPReason.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.NPWPReason;
        $scope.CIFInvestor.NatureOfBusinessText=$scope.CIFInvestor.NatureOfBusinessText?$scope.CIFInvestor.NatureOfBusinessText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.NatureOfBusinessText;
        $scope.CIFInvestor.Note=$scope.CIFInvestor.Note?$scope.CIFInvestor.Note.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Note;
        $scope.CIFInvestor.OccupationText=$scope.CIFInvestor.OccupationText?$scope.CIFInvestor.OccupationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.OccupationText;
        $scope.CIFInvestor.PositionText=$scope.CIFInvestor.PositionText?$scope.CIFInvestor.PositionText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.PositionText;
        $scope.CIFInvestor.Question1=$scope.CIFInvestor.Question1?$scope.CIFInvestor.Question1.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question1;
        $scope.CIFInvestor.Question1_Text=$scope.CIFInvestor.Question1_Text?$scope.CIFInvestor.Question1_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question1_Text;
        $scope.CIFInvestor.Question2=$scope.CIFInvestor.Question2?$scope.CIFInvestor.Question2.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question2;
        $scope.CIFInvestor.Question2_Text=$scope.CIFInvestor.Question2_Text?$scope.CIFInvestor.Question2_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question2_Text;
        $scope.CIFInvestor.Question3=$scope.CIFInvestor.Question3?$scope.CIFInvestor.Question3.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question3;
        $scope.CIFInvestor.Question3_Text=$scope.CIFInvestor.Question3_Text?$scope.CIFInvestor.Question3_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question3_Text;
        $scope.CIFInvestor.Question4=$scope.CIFInvestor.Question4?$scope.CIFInvestor.Question4.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question4;
        $scope.CIFInvestor.Question4_Text=$scope.CIFInvestor.Question4_Text?$scope.CIFInvestor.Question4_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question4_Text;
        $scope.CIFInvestor.Question5=$scope.CIFInvestor.Question5?$scope.CIFInvestor.Question5.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question5;
        $scope.CIFInvestor.Question5_Text=$scope.CIFInvestor.Question5_Text?$scope.CIFInvestor.Question5_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question5_Text;
        $scope.CIFInvestor.Question6=$scope.CIFInvestor.Question6?$scope.CIFInvestor.Question6.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question6;
        $scope.CIFInvestor.Question6_Text=$scope.CIFInvestor.Question6_Text?$scope.CIFInvestor.Question6_Text.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.Question6_Text;
        $scope.CIFInvestor.QuestionFATCA=$scope.CIFInvestor.QuestionFATCA?$scope.CIFInvestor.QuestionFATCA.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.QuestionFATCA;
        $scope.CIFInvestor.ReferalNumber=$scope.CIFInvestor.ReferalNumber?$scope.CIFInvestor.ReferalNumber.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.ReferalNumber;
        $scope.CIFInvestor.SpouseCompanyAddress=$scope.CIFInvestor.SpouseCompanyAddress?$scope.CIFInvestor.SpouseCompanyAddress.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseCompanyAddress;
        $scope.CIFInvestor.SpouseCompanyName=$scope.CIFInvestor.SpouseCompanyName?$scope.CIFInvestor.SpouseCompanyName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseCompanyName;
        $scope.CIFInvestor.SpouseCompanyPostalCode=$scope.CIFInvestor.SpouseCompanyPostalCode?$scope.CIFInvestor.SpouseCompanyPostalCode.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseCompanyPostalCode;
        $scope.CIFInvestor.SpouseFundSource=$scope.CIFInvestor.SpouseFundSource?$scope.CIFInvestor.SpouseFundSource.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseFundSource;
        $scope.CIFInvestor.SpouseFundSourceText=$scope.CIFInvestor.SpouseFundSourceText?$scope.CIFInvestor.SpouseFundSourceText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseFundSourceText;
        $scope.CIFInvestor.SpouseName=$scope.CIFInvestor.SpouseName?$scope.CIFInvestor.SpouseName.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseName;
        $scope.CIFInvestor.SpouseNatureOfBusiness=$scope.CIFInvestor.SpouseNatureOfBusiness?$scope.CIFInvestor.SpouseNatureOfBusiness.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseNatureOfBusiness;
        $scope.CIFInvestor.SpouseOccupationText=$scope.CIFInvestor.SpouseOccupationText?$scope.CIFInvestor.SpouseOccupationText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseOccupationText;
        $scope.CIFInvestor.SpousePosition=$scope.CIFInvestor.SpousePosition?$scope.CIFInvestor.SpousePosition.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpousePosition;
        $scope.CIFInvestor.SpouseRelationship=$scope.CIFInvestor.SpouseRelationship?$scope.CIFInvestor.SpouseRelationship.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseRelationship;
        $scope.CIFInvestor.SpouseRelationshipText=$scope.CIFInvestor.SpouseRelationshipText?$scope.CIFInvestor.SpouseRelationshipText.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/gi, ''):$scope.CIFInvestor.SpouseRelationshipText;
        
    }

    $scope.submit = function () {

        $scope.trim();
        $scope.prepareData();
        var urlsvc = 'service/client.svc/SaveCIF'; // 1
        var postData = { cifdata: $scope.CIFInvestor } // 2
        var preconfirmtranslate = "submitCif3"; // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/cif/data-pernyataan";
        });

    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };


}]);


